var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("table", { staticClass: "table table-striped" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _vm._v(_vm._s(_vm.$t("kanban.approval.listModal.table.date")))
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("kanban.approval.listModal.table.user")))
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(
                _vm._s(_vm.$t("kanban.approval.listModal.table.cardCount"))
              )
            ]),
            _vm._v(" "),
            _c("th")
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.state.openApprovals, function(request) {
            return _c("tr", { key: request.id }, [
              _c("td", [_vm._v(_vm._s(_vm.formatDateTime(request.createdOn)))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.getUsername(request.createdBy)))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.$t("kanban.approval.listModal.table.xCards", [
                      (request.cards || []).length
                    ])
                  )
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.openRequest(request)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-signature" })]
                )
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("ApprovalApproveModal", {
        ref: "approveModal",
        attrs: { state: _vm.state },
        on: {
          openCard: function($event) {
            return _vm.$emit("openCard", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }